import captureDrop from './captureDrop'

export default async function(
  box: HTMLElement,
  event: DragEvent,
  callback: (isOut: boolean) => any
): Promise<boolean> {
  const el = event.currentTarget as HTMLElement

  const boxRect = box.getBoundingClientRect()
  const rect = el.getBoundingClientRect()

  const { left: boxLeft, right: boxRight, top: boxTop, bottom: boxBottom } = boxRect

  const clientX = event.clientX
  const clientY = event.clientY

  const dxLeft = Math.max(0, clientX - rect.left)
  const dxRight = rect.width - dxLeft
  const dyTop = Math.max(0, clientY - rect.top)
  const dyBottom = rect.height - dyTop

  let isOut = false

  const checkIsOut = (ev: Event) => {
    if ('clientX' in ev && 'clientY' in ev) {
      const x = (ev as any).clientX
      const y = (ev as any).clientY
      const left = x - dxLeft
      const right = x + dxRight
      const top = y - dyTop
      const bottom = y + dyBottom
      const out = right < boxLeft || left > boxRight || bottom < boxTop || top > boxBottom
      return out
    }
    return isOut
  }

  return new Promise(async resolve => {
    const handler = (ev: DragEvent) => {
      isOut = checkIsOut(ev)
      callback(isOut)
    }
    el.addEventListener('drag', handler, true)

    const finalEvent = await captureDrop()
    const finalIsOut = checkIsOut(finalEvent)
    el.removeEventListener('drag', handler, true)

    callback(finalIsOut)
    resolve(finalIsOut)
  })
}
